import { useLang } from "@/context/LanguageContext";
import { Home, BookOpen, Bike } from "lucide-react";

export default function About() {
  const { t } = useLang();

  const pillars = [
    {
      icon: Home,
      title: t.about.live.title,
      text: t.about.live.text,
      delay: "0.1s",
    },
    {
      icon: BookOpen,
      title: t.about.learn.title,
      text: t.about.learn.text,
      delay: "0.2s",
    },
    {
      icon: Bike,
      title: t.about.ride.title,
      text: t.about.ride.text,
      delay: "0.3s",
    },
  ];

  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 sm:py-32 bg-[#0A0A0A]"
    >
      {/* Background texture */}
      <div
        className="absolute inset-0 opacity-5 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://images.unsplash.com/photo-1770795263316-f302a878ee64?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxibGFjayUyMHRleHR1cmUlMjBkYXJrJTIwYmFja2dyb3VuZHxlbnwwfHx8fDE3NzU5MzYyNDN8MA&ixlib=rb-4.1.0&q=85')`,
        }}
      />

      <div className="relative max-w-7xl mx-auto px-6">
        {/* Section Label */}
        <div className="flex items-center gap-3 mb-4">
          <div className="w-8 h-[2px] bg-[#FF3B30]" />
          <span className="text-xs uppercase tracking-[0.3em] text-[#A3A3A3] font-body">
            {t.about.label}
          </span>
        </div>

        {/* Title */}
        <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl uppercase tracking-tight text-white mb-6">
          {t.about.title}
        </h2>

        {/* Description */}
        <p className="text-sm sm:text-base text-[#A3A3A3] font-body leading-relaxed max-w-3xl mb-16">
          {t.about.description}
        </p>

        {/* Pillars Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {pillars.map((pillar) => (
            <div
              key={pillar.title}
              className="group bg-[#111111] border border-[#262626] p-8 hover:border-[#FF3B30] transition-all hover:-translate-y-1 animate-fade-in"
              style={{ animationDelay: pillar.delay }}
            >
              <pillar.icon className="w-8 h-8 text-[#FF3B30] mb-6 transition-transform group-hover:scale-110" />
              <h3 className="font-heading text-2xl uppercase tracking-wider text-white mb-4">
                {pillar.title}
              </h3>
              <p className="text-sm text-[#A3A3A3] font-body leading-relaxed">
                {pillar.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
